import { createContext, useContext } from "react";

export type ShellApi = {
  openPalette: () => void;
  openShortcuts: () => void;
  openNewSeason: () => void;
  /** Remove an empty season opened by mistake (administrators). */
  openDeleteSeason: () => void;
  /** Open the working-season menu of the top bar (the year chip of a page header calls it). */
  openSeason: () => void;
  seasonOpen: boolean;
  setSeasonOpen: (open: boolean) => void;
};

const noop = () => {};
export const ShellContext = createContext<ShellApi>({
  openPalette: noop,
  openShortcuts: noop,
  openNewSeason: noop,
  openDeleteSeason: noop,
  openSeason: noop,
  seasonOpen: false,
  setSeasonOpen: noop,
});

export const useShell = () => useContext(ShellContext);
